import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth, Text } from '@calm-web/design-system';

import OnboardingNavButtons from '../../Components/OnboardingNavButtons';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	flex: 1;
	z-index: 0;

	${minWidth('mobileLarge')} {
		padding-bottom: 36px;
	}

	${minWidth('tablet')} {
		margin-top: 44px;
		min-height: none;
		padding-bottom: 60px;
	}

	${minWidth('desktop')} {
		margin-top: 0;
		padding-bottom: 20px;
	}

	${minWidth('desktopLarge')} {
		padding-bottom: 40px;
	}
`;

export const ContentWrapper = styled.div`
	margin-top: auto;
`;

export const Content = styled.div`
	background: ${palette('white')};
	border-radius: 16px;
	box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.12);
	padding: 12px;
`;

export const Quote = styled(Text)`
	margin: 14px 0 12px;
`;

export const Author = styled(Text)`
	font-size: 13.5px;
	${fontWeight(FontWeights.Medium)};
`;

export const ContinueButton = styled(OnboardingNavButtons)`
	margin-top: 8px;

	${minWidth('desktop')} {
		margin-bottom: 0;
		margin-top: 20px;
	}
`;
